module.exports = __webpack_public_path__ + "static/media/item9.9e1eb6da.jpg";